// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5f6dc117","732":"ffbf84d0","977":"b804e21c"}[chunkId] + ".chunk.js";
};